import Vue from "vue";

export const formatCNPJ = value =>
  value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");

export const formatCPF = value =>
  value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

export const formatDocument = value =>
  value.length > 11 ? formatCNPJ(value) : formatCPF(value);

Vue.filter("document", value => {
  if (!value) {
    return "";
  }

  return formatDocument(value);
});
